module.exports = __webpack_public_path__ + "static/media/leafItToMe.e7b48f19.jpg";